let isClientLoaded = false;

const loadClient = () => {
    return new Promise<boolean>((resolve) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        window.document.head.append(script);
        script.onload = () => {
            isClientLoaded = true;
            resolve(true);
        };
        script.onerror = (error) => {
            console.error('Failed to load OAuth One Tap script', error);
            resolve(false);
        };
    });
};

const show = async (clientId: string, callback: (jwt: string) => void) => {
    if (!isClientLoaded) {
        await loadClient();
    }

    window.google?.accounts?.id?.initialize({
        client_id: clientId,
        callback: (response: { credential: string; select_by: string }) => callback(response?.credential),
        cancel_on_tap_outside: false,
        context: 'signin',
    });

    window.google?.accounts?.id?.prompt();
};

export const oneTapService = { show };
